/**
 *
 * Asynchronously loads the component for GenericField
 *
 */

import { lazyLoad } from 'utils/loadable';

export const GenericField = lazyLoad(
  () => import('./index'),
  module => module.GenericField,
);
